import { MouseEvent, useState } from 'react';
import { CART_URL, formatOrderData, handleSuccessRequest } from '@beef/layout-kit/utils';
import { setCartData } from '@beef/layout-kit/actions';

import { fetchCatalogBasketInfo } from 'pages/TariffsCatalog2021/api/fetchCatalogBasketInfo';
import { TTariffInfo } from 'pages/TariffsCatalog2021/components/BuySimModal/types';
import globalStore from 'store';
import { useIsDesktopDimension } from 'utils/hooks/useGetDimensionGroup';
import { GET_DPC_ID, GET_TO_BASKET } from 'pages/ESIMPurchase/constants';
import { ymPushEvent, ymPushParams } from 'utils/ym';
import { getModalClicksAnalytics } from 'pages/TariffsCatalog2021/components/BuySimModal/utils/getModalClicksAnalytics';

// Хук с формированием обработчиков ссылок и кнопок внутри модалки покупки сим
export const useChooseSimType = (tariffInfo: TTariffInfo, title: string) => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [isShowEsimInstruction, setIsShowEsimInstruction] = useState(false);
  const isDesktop = useIsDesktopDimension();

  const onClickSim = async () => {
    try {
      setIsDisabled(true);
      const { cartApi } = globalStore.getState().external.cartData;
      const basketPayload = (await fetchCatalogBasketInfo(tariffInfo.soc)) || {};
      ymPushParams(
        getModalClicksAnalytics({
          item_type: 'button',
          button_text: 'пластиковая сим',
          popup_title: title,
        }),
      );
      ymPushEvent('MobTariffsESIM', { URL6: document.location.href });
      ymPushEvent('MobTariffsToDetail', { URL6: document.location.href });

      // @ts-expect-error - кто-то ввел для formatOrderData обязательный параметр additionalCtnOptions: Object
      const requestData = formatOrderData(basketPayload);
      const { data } = await cartApi.post(requestData.apiEndpoint, requestData.body);
      if (data.id) {
        handleSuccessRequest({
          cartId: data.id,
          items: data.items,
        });

        globalStore.dispatch(setCartData(data));

        if (typeof window !== 'undefined') {
          window.location.href = CART_URL;
        }
      }
    } catch (e) {
      console.error(e, 'Ошибка добавления пластиковой сим в корзину');
    } finally {
      setIsDisabled(false);
    }
  };

  const onClickESim = (e: MouseEvent<HTMLAnchorElement | HTMLButtonElement>) => {
    ymPushParams(
      getModalClicksAnalytics({
        item_type: 'button',
        button_text: 'eSIM',
        popup_title: title,
      }),
    );
    ymPushEvent('MobTariffsESIM', { URL6: document.location.href });
    ymPushEvent('MobTariffsToDetail', { URL6: document.location.href });

    if (isDesktop) {
      e.preventDefault();
      setIsShowEsimInstruction(true);
    }
  };

  // Ссылка на покупку esim c предвыбранным тарифом
  const eSimOrderTariffLink = `${tariffInfo.eSimOrderLink}?${GET_TO_BASKET}=true&${GET_DPC_ID}=${tariffInfo.dpcId}`;

  return {
    onClickSim,
    onClickESim,
    isDisabled,
    isShowEsimInstruction,
    setIsShowEsimInstruction,
    eSimOrderTariffLink,
  };
};
